import styled from 'styled-components';

export const Main = styled.div`
  width: calc(768px + (2 * var(--layout-05)));
  padding: var(--layout-01) var(--layout-05) var(--layout-03);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
